var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_346)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -17.8333,
    y: -17.834,
    width: 75.6667,
    height: 189,
    rx: 4.5,
    stroke: "#9747FF",
    strokeDasharray: "10 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 18.3327H38.3334V21.666H33.3334V18.3327ZM1.66669 18.3327H6.66669V21.666H1.66669V18.3327ZM21.6667 1.66602V6.66602H18.3334V1.66602H21.6667ZM8.20002 5.83268L11.75 9.39935L9.38335 11.7493L5.83335 8.21602L8.20002 5.83268ZM28.25 9.38268L31.7834 5.83268L34.1667 8.21602L30.6167 11.7493L28.25 9.38268ZM20 9.99935C22.6522 9.99935 25.1957 11.0529 27.0711 12.9283C28.9465 14.8036 30 17.3472 30 19.9993C30 23.6994 27.9834 26.9327 25 28.666V31.666C25 32.108 24.8244 32.532 24.5119 32.8445C24.1993 33.1571 23.7754 33.3327 23.3334 33.3327H16.6667C16.2247 33.3327 15.8007 33.1571 15.4882 32.8445C15.1756 32.532 15 32.108 15 31.666V28.666C12.0167 26.9327 10 23.6994 10 19.9993C10 17.3472 11.0536 14.8036 12.929 12.9283C14.8043 11.0529 17.3479 9.99935 20 9.99935ZM23.3334 34.9994V36.666C23.3334 37.108 23.1578 37.532 22.8452 37.8445C22.5326 38.1571 22.1087 38.3327 21.6667 38.3327H18.3334C17.8913 38.3327 17.4674 38.1571 17.1548 37.8445C16.8423 37.532 16.6667 37.108 16.6667 36.666V34.9994H23.3334ZM18.3334 29.9993H21.6667V26.4494C24.55 25.716 26.6667 23.0993 26.6667 19.9993C26.6667 18.2312 25.9643 16.5355 24.7141 15.2853C23.4638 14.0351 21.7681 13.3327 20 13.3327C18.2319 13.3327 16.5362 14.0351 15.286 15.2853C14.0357 16.5355 13.3334 18.2312 13.3334 19.9993C13.3334 23.0993 15.45 25.716 18.3334 26.4494V29.9993Z",
    fill: "#85B6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.e38c8968f66a93a69397de4498975ed7.svg";
export { ForwardRef as ReactComponent };